<template>
  <v-container fluid class="px-8">
    <slot />
  </v-container>
</template>

<script>
export default {
  props: {
    drawerWidth: { type: Number, default: 280 },
  },
}
</script>
